const ENTERPRISE_MEMBERSHIPS: ReadonlyArray<string | undefined> = [
  'ENTERPRISE',
  'EBP',
  'EBP_ADMIN_NO_SEAT',
]

export const isEnterpriseMembership = (membership?: string): boolean =>
  ENTERPRISE_MEMBERSHIPS.includes(membership)
